export default "__VITE_ASSET__BVsQgpeL__"